import React from 'react';

import type { ForwardRefComponent } from '@coursera/cds-common';

import type { CommonActionsProps } from '@core/dialogs/common/types';

import { useDialogContext } from './DialogContextProvider';
import { getActionsCss, getStickyActionsCss } from './styles';

type ActionsType = ForwardRefComponent<HTMLDivElement, Props>;

export type Props = CommonActionsProps;

const stickyStyles = getStickyActionsCss();

const Actions: ActionsType = React.forwardRef(function Actions(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const { sticky, alignment, slotOrientation, width } = useDialogContext();
  const { children, ...rest } = props;

  const hasSlot = slotOrientation !== undefined;

  return (
    <div
      ref={ref}
      css={[
        getActionsCss({ width, alignment, hasSlot, slotOrientation }),
        sticky === 'actions' && stickyStyles,
      ]}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Actions;
